import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { S08BlogListingProps } from './S08BlogListing.types';
import { useI18n } from 'next-localization';

export type S08BlogListingModel = {
  site?: string;
  section: string[];
  dataModel: {
    numberOfSearchResultsPerPage: number;
    noResultsText: string;
    searchFieldPlaceholder: string;
    searchFieldLabel: string;
    searchButtonText: string;
    placeholderImage: string;
  };
};

export function CreateS08BlogListingModel(props: S08BlogListingProps): S08BlogListingModel {
  const { sitecoreContext } = useSitecoreContext();
  const { t } = useI18n();
  const { fields, params } = props;

  const site = sitecoreContext?.site?.name;

  const section =
    fields?.ScopeSearchToSection?.filter((i) => i.url)?.map((s) => s.url as string) || [];

  return {
    site,
    section,
    dataModel: {
      numberOfSearchResultsPerPage: parseInt(params?.NumberOfSearchResultsPerPage ?? '5'),
      noResultsText: fields?.NoResultsText?.value || '<p>No results found</p>',
      searchFieldPlaceholder: t('BlogListing-SearchFieldPlaceholder') || 'Enter a search term',
      searchFieldLabel: t('BlogListing-SearchFieldLabel') || 'Search blogs',
      searchButtonText: t('BlogListing-SearchButtonText') || 'Search',
      placeholderImage: fields?.PlaceholderImage?.value?.src || '',
    },
  };
}
